// extracted by mini-css-extract-plugin
export default {"check-box-group":"radio-group_check-box-group__sR0Va","lable-style":"radio-group_lable-style__ju6X7"};